import { CSSObject } from "styled-components";

//App
import { vfxTheme } from "../../common/VFX-UI/Theme/theme";

interface stateStyles {
    searchContainer: CSSObject;
    actionBarContainer: CSSObject;
}

const useStateStyles = (): stateStyles => {
  return {
    searchContainer: {
      display: "flex",
          marginBottom: vfxTheme.spaceUnits.sp03,
          marginTop: vfxTheme.spaceUnits.sp03,
      },
      actionBarContainer: {
          marginTop: vfxTheme.spaceUnits.sp03,
      },
  };
};

export default useStateStyles;


